<template>
  <div>
    <fieldset class="content-group">
      <div class="row">
        <div class="col-md-12">
          <div
            :class="{'has-warning': errors.has(`${formName}.phone`)}"
            class="form-group"
          >
            <label>
              {{ $t(`${tForm}.phone`) }}
            </label>
            <input
              v-validate="'required'"
              :data-vv-as="$t(`${tForm}.phone`).toLowerCase()"
              :data-vv-scope="formName"
              :readonly="isEdit"
              :value="value_.phone"
              class="form-control"
              name="phone"
              type="text"
            >
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.name`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.name_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.name"
              class="form-control"
              type="text"
            >
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.first_name`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.first_name_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.first_name"
              class="form-control"
              type="text"
            >
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.last_name`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.last_name_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.last_name"
              class="form-control"
              type="text"
            >
          </div>
        </div>

        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.second_name`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.second_name_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.second_name"
              class="form-control"
              type="text"
            >
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.email`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.email_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.email"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.birth_day`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.birth_day_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.birth_day"
              class="form-control"
              type="text"
            >
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.code`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.code_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.code"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.sum`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.sum_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.sum"
              class="form-control"
              type="text"
            >
          </div>
        </div>


        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.date`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.date_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.date"
              class="form-control"
              type="text"
            >
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.param_1`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.param_1_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.param_1"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.param_2`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.param_2_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.param_2"
              class="form-control"
              type="text"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label>
              {{ $t(`${tForm}.param_3`) }}
              <span class="badge badge-light ml-3">
                {{ $t(`${tForm}.param_3_tag`) }}
              </span>
            </label>
            <input
              v-model="value_.param_3"
              class="form-control"
              type="text"
            >
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    formName: {
      type: String,
      default: '',
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tForm: 'room.header.add_contact.form',
    };
  },
  computed: {
    value_: {
      deep: true,
      get() {
        return this.value;
      },
      set(value) {
        this.emit('input', value);
      },
    },
  },
};
</script>

<style scoped>

</style>
